import script from "./KendouSeriesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./KendouSeriesPage.vue?vue&type=script&setup=true&lang=js"

import "./KendouSeriesPage.vue?vue&type=style&index=0&id=1cc81fed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc81fed"]])

export default __exports__